<template>
  <div style="padding-top: 55px; position: relative;">
    <div class="store-search-container">
      <el-form :inline="true">
        <el-form-item label="产品">
          <el-select v-model="query.productId" filterable placeholder="请选择产品" style="width: 300px;" @change="handlerProductChange">
            <el-option v-for="item in products" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="页码" style="margin-left: 30px;">
          <el-select v-model="query.pageCode" multiple placeholder="页码" style="width: 300px;">
            <el-option v-for="item in pageCodes" :key="item.value" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="品番" style="margin-left: 30px;">
          <el-select v-model="query.designation" placeholder="品番" clearable style="width: 300px;">
            <el-option v-for="(item, index) in designations" :key="index" :label="item.merchandiseNumber" :value="item.merchandiseNumber"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handlerQueryLocation">查询</el-button>
          <el-button type="warning" @click="handlerClear">清空</el-button>
          <el-button type="success" @click="handlerRefresh">刷新</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 社内区域标识说明 -->
    <table class="third-area" cellpadding="0" cellspacing="0">
      <tbody>
        <tr>
            <td rowspan="2" colspan="1" style="border-right-width: 2px; font-weight: 700;">1</td>
            <template v-for="(item, index) in aColumns">
              <td :key="index + '-1'">{{item}}1-2</td>
              <td :key="index + '-2'" v-if="(index + 1) % 2 === 0" rowspan="16" colspan="1" style="border-left: 1px solid #333; border-right: 2px solid #333; background: #EBF1DE;">通道</td>
            </template>
        </tr>
        <tr>
            <td v-for="(item, index) in aColumns" :key="index" class="dashed">{{item}}1-1</td>
        </tr>
        <tr>
            <td rowspan="2" colspan="1" style="border-right-width: 2px; font-weight: 700;">2</td>
            <td v-for="(item, index) in aColumns" :key="index">{{item}}2-2</td>
        </tr>
        <tr>
            <td v-for="(item, index) in aColumns" :key="index" class="dashed">{{item}}2-1</td>
        </tr>
        <tr>
            <td rowspan="2" colspan="1" style="border-right-width: 2px; font-weight: 700;">3</td>
            <td v-for="(item, index) in aColumns" :key="index">{{item}}3-2</td>
        </tr>
        <tr>
            <td v-for="(item, index) in aColumns" :key="index" class="dashed">{{item}}3-1</td>
        </tr>
        <tr>
            <td rowspan="2" colspan="1" style="border-right-width: 2px; font-weight: 700;">4</td>
            <td v-for="(item, index) in aColumns" :key="index">{{item}}4-2</td>
        </tr>
        <tr>
            <td v-for="(item, index) in aColumns" :key="index" class="dashed">{{item}}4-1</td>
        </tr>
        <tr>
            <td rowspan="2" colspan="1" style="border-right-width: 2px; font-weight: 700;">5</td>
            <td v-for="(item, index) in aColumns" :key="index">{{item}}5-2</td>
        </tr>
        <tr>
            <td v-for="(item, index) in aColumns" :key="index" class="dashed">{{item}}5-1</td>
        </tr>
        <tr>
            <td rowspan="2" colspan="1" style="border-right-width: 2px; font-weight: 700;">6</td>
            <td v-for="(item, index) in aColumns" :key="index">{{item}}6-2</td>
        </tr>
        <tr>
            <td v-for="(item, index) in aColumns" :key="index" class="dashed">{{item}}6-1</td>
        </tr>
        <tr>
            <td rowspan="2" colspan="1" style="border-right-width: 2px; font-weight: 700;">7</td>
            <td v-for="(item, index) in aColumns" :key="index">{{item}}7-2</td>
        </tr>
        <tr>
          <td v-for="(item, index) in aColumns" :key="index" class="dashed">{{item}}7-1</td>
        </tr>
        <tr>
          <td rowspan="2" colspan="1" style="border-right-width: 2px; font-weight: 700;">8</td>
          <td v-for="(item, index) in aColumns" :key="index">{{item}}8-2</td>
        </tr>
        <tr>
          <td v-for="(item, index) in aColumns" :key="index" class="dashed">{{item}}8-1</td>
        </tr>
      </tbody>
    </table>
    <table class="third-area" cellpadding="0" cellspacing="0" style="border: none">
      <tr>
          <td style="width: 70px; border: none;"></td>
          <template v-for="(item, index) in aColumns">
            <td :key="index + '-1'" :class="(index % 2 === 0) ? 'color1' : 'color2'" style="width: 69px; border: none;">{{item}}</td>
            <td :key="index + '-2'" v-if="(index + 1) % 2 === 0" style="width: 71px; border: none;"></td>
          </template>
      </tr>
    </table>
    <h2>粘贴A组台纸区域</h2>
    <div style="width: 1533px; margin: 0 auto;">
      <table cellpadding="0" cellspacing="0" style="width： 100%">
        <tr>
          <td style="width: 300px;">
            <table class="third-area" cellpadding="0" cellspacing="0" style="border: none">
              <tr>
                  <td class="color1" style="width: 72px; border: none; font-weight: 700;">TA</td>
              </tr>
            </table>
            <table class="third-area" cellpadding="0" cellspacing="0" style="border-right-width: 1px;">
              <tbody>
                <tr v-for="(item, index) in taRows" :key="index">
                  <td :class="index > 0 ? 'dashed' : ''" style="">TA-{{item}}</td>
                </tr>
              </tbody>
            </table>
          </td>
          <td style="width: 417px; vertical-align: top">
            <table class="third-area" cellpadding="0" cellspacing="0" style="border: none">
              <tr>
                  <td style="width: 72px; border: none;">1</td>
                  <td style="width: 72px; border: none;">2</td>
                  <td style="width: 72px; border: none;">3</td>
                  <td style="width: 72px; border: none;">4</td>
                  <td style="width: 72px; border: none;">5</td>
                  <td style="width: 72px; border: none;">6</td>
              </tr>
            </table>
            <table class="third-area third-area-zhantie" cellpadding="0" cellspacing="0" style="border-right-width: 1px;">
              <tbody>
                <tr>
                  <td>TB-1</td>
                  <td>TB-2</td>
                  <td>TB-3</td>
                  <td>TB-4</td>
                  <td>TB-5</td>
                  <td>TB-6</td>
                </tr>
                <tr>
                  <td>TC-1</td>
                  <td>TC-2</td>
                  <td>TC-3</td>
                  <td>TC-4</td>
                  <td>TC-5</td>
                  <td>TC-6</td>
                </tr>
                <tr>
                  <td class="color2" colspan="6" style="background: #EBF1DE;">通道</td>
                </tr>
                <tr>
                  <td>TD-1</td>
                  <td>TD-2</td>
                  <td>TD-3</td>
                  <td>TD-4</td>
                  <td>TD-5</td>
                  <td>TD-6</td>
                </tr>
                <tr>
                  <td>TE-1</td>
                  <td>TE-2</td>
                  <td>TE-3</td>
                  <td>TE-4</td>
                  <td>TE-5</td>
                  <td>TE-6</td>
                </tr>
              </tbody>
            </table>
            <table class="third-area" cellpadding="0" cellspacing="0" style="border: none">
              <tr>
                  <td style="width: 72px; border: none;">1</td>
                  <td style="width: 72px; border: none;">2</td>
                  <td style="width: 72px; border: none;">3</td>
                  <td style="width: 72px; border: none;">4</td>
                  <td style="width: 72px; border: none;">5</td>
                  <td style="width: 72px; border: none;">6</td>
              </tr>
            </table>
          </td>
          <td style="vertical-align: top">
            <table class="third-area third-area-zhantie" cellpadding="0" cellspacing="0" style="border: none">
              <tr style="height: 32px;">
                <td style="width: 72px; border: none;"></td>
              </tr>
              <tr>
                <td class="color1" style="width: 72px; border: none;">TB</td>
              </tr>
              <tr>
                <td class="color1" style="width: 72px; border: none;">TC</td>
              </tr>
              <tr>
                <td style="width: 72px; border: none;"></td>
              </tr>
              <tr>
                <td class="color1" style="width: 72px; border: none;">TD</td>
              </tr>
              <tr>
                <td class="color1" style="width: 72px; border: none;">TE</td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
    <div style="height: 20px; background-color: #E26B0A; margin: 20px auto;"><!----------------------></div>
    <table class="third-area" cellpadding="0" cellspacing="0">
      <tbody>
        <tr>
            <td rowspan="2" colspan="1" style="border-right-width: 2px; font-weight: 700;">1</td>
            <template v-for="(item, index) in bColumns">
              <td :key="index + '-1'">{{item}}1-2</td>
              <td :key="index + '-2'" v-if="(index + 1) % 2 === 0" rowspan="16" colspan="1" style="border-left: 1px solid #333; border-right: 2px solid #333; background: #EBF1DE;">通道</td>
            </template>
        </tr>
        <tr>
            <td v-for="(item, index) in bColumns" :key="index" class="dashed">{{item}}1-1</td>
        </tr>
        <tr>
            <td rowspan="2" colspan="1" style="border-right-width: 2px; font-weight: 700;">2</td>
            <td v-for="(item, index) in bColumns" :key="index">{{item}}2-2</td>
        </tr>
        <tr>
            <td v-for="(item, index) in bColumns" :key="index" class="dashed">{{item}}2-1</td>
        </tr>
        <tr>
            <td rowspan="2" colspan="1" style="border-right-width: 2px; font-weight: 700;">3</td>
            <td v-for="(item, index) in bColumns" :key="index">{{item}}3-2</td>
        </tr>
        <tr>
            <td v-for="(item, index) in bColumns" :key="index" class="dashed">{{item}}3-1</td>
        </tr>
        <tr>
            <td rowspan="2" colspan="1" style="border-right-width: 2px; font-weight: 700;">4</td>
            <td v-for="(item, index) in bColumns" :key="index">{{item}}4-2</td>
        </tr>
        <tr>
            <td v-for="(item, index) in bColumns" :key="index" class="dashed">{{item}}4-1</td>
        </tr>
        <tr>
            <td rowspan="2" colspan="1" style="border-right-width: 2px; font-weight: 700;">5</td>
            <td v-for="(item, index) in bColumns" :key="index">{{item}}5-2</td>
        </tr>
        <tr>
            <td v-for="(item, index) in bColumns" :key="index" class="dashed">{{item}}5-1</td>
        </tr>
        <tr>
            <td rowspan="2" colspan="1" style="border-right-width: 2px; font-weight: 700;">6</td>
            <td v-for="(item, index) in bColumns" :key="index">{{item}}6-2</td>
        </tr>
        <tr>
            <td v-for="(item, index) in bColumns" :key="index" class="dashed">{{item}}6-1</td>
        </tr>
        <tr>
            <td rowspan="2" colspan="1" style="border-right-width: 2px; font-weight: 700;">7</td>
            <td v-for="(item, index) in bColumns" :key="index">{{item}}7-2</td>
        </tr>
        <tr>
          <td v-for="(item, index) in bColumns" :key="index" class="dashed">{{item}}7-1</td>
        </tr>
        <tr>
          <td rowspan="2" colspan="1" style="border-right-width: 2px; font-weight: 700;">8</td>
          <td v-for="(item, index) in bColumns" :key="index">{{item}}8-2</td>
        </tr>
        <tr>
          <td v-for="(item, index) in bColumns" :key="index" class="dashed">{{item}}8-1</td>
        </tr>
      </tbody>
    </table>
    <table class="third-area" cellpadding="0" cellspacing="0" style="border: none">
      <tr>
          <td style="width: 70px; border: none;"></td>
          <template v-for="(item, index) in bColumns">
            <td :key="index + '-1'" :class="(index % 2 === 0) ? 'color1' : 'color2'" style="width: 69px; border: none;">{{item}}</td>
            <td :key="index + '-2'" v-if="(index + 1) % 2 === 0" style="width: 71px; border: none;"></td>
          </template>
      </tr>
    </table>
    <h2>粘贴B组台纸区域</h2>
    <div style="width: 1533px; margin: 0 auto;">
      <table cellpadding="0" cellspacing="0" style="width： 100%">
        <tr>
          <td style="width: 150px; vertical-align: top">
            <table class="third-area" cellpadding="0" cellspacing="0" style="border: none">
              <tr>
                  <td class="color1" style="width: 72px; border: none; font-weight: 700;">TF</td>
              </tr>
            </table>
            <table class="third-area" cellpadding="0" cellspacing="0" style="border-right-width: 1px;">
              <tbody>
                <tr v-for="(item, index) in tfRows" :key="index">
                  <td :class="index > 0 ? 'dashed' : ''" style="">TF-{{item}}</td>
                </tr>
              </tbody>
            </table>
          </td>
          <td style="width: 300px; vertical-align: top">
            <table class="third-area" cellpadding="0" cellspacing="0" style="border: none">
              <tr>
                  <td class="color1" style="width: 72px; border: none; font-weight: 700;">TG</td>
              </tr>
            </table>
            <table class="third-area" cellpadding="0" cellspacing="0" style="border-right-width: 1px;">
              <tbody>
                <tr v-for="(item, index) in tgRows" :key="index">
                  <td :class="index > 0 ? 'dashed' : ''" style="">TG-{{item}}</td>
                </tr>
              </tbody>
            </table>
          </td>
          <td style="width: 417px; vertical-align: top">
            <table class="third-area" cellpadding="0" cellspacing="0" style="border: none">
              <tr>
                  <td style="width: 72px; border: none;">1</td>
                  <td style="width: 72px; border: none;">2</td>
                  <td style="width: 72px; border: none;">3</td>
                  <td style="width: 72px; border: none;">4</td>
                  <td style="width: 72px; border: none;">5</td>
                  <td style="width: 72px; border: none;">6</td>
              </tr>
            </table>
            <table class="third-area third-area-zhantie" cellpadding="0" cellspacing="0" style="border-right-width: 1px;">
              <tbody>
                <tr>
                  <td>TH-1</td>
                  <td>TH-2</td>
                  <td>TH-3</td>
                  <td>TH-4</td>
                  <td>TH-5</td>
                  <td>TH-6</td>
                </tr>
                <tr>
                  <td>TJ-1</td>
                  <td>TJ-2</td>
                  <td>TJ-3</td>
                  <td>TJ-4</td>
                  <td>TJ-5</td>
                  <td>TJ-6</td>
                </tr>
                <tr>
                  <td class="color2" colspan="6" style="background: #EBF1DE;">通道</td>
                </tr>
                <tr>
                  <td>TK-1</td>
                  <td>TK-2</td>
                  <td>TK-3</td>
                  <td>TK-4</td>
                  <td>TK-5</td>
                  <td>TK-6</td>
                </tr>
                <tr>
                  <td>TL-1</td>
                  <td>TL-2</td>
                  <td>TL-3</td>
                  <td>TL-4</td>
                  <td>TL-5</td>
                  <td>TL-6</td>
                </tr>
              </tbody>
            </table>
            <table class="third-area" cellpadding="0" cellspacing="0" style="border: none">
              <tr>
                  <td style="width: 72px; border: none;">1</td>
                  <td style="width: 72px; border: none;">2</td>
                  <td style="width: 72px; border: none;">3</td>
                  <td style="width: 72px; border: none;">4</td>
                  <td style="width: 72px; border: none;">5</td>
                  <td style="width: 72px; border: none;">6</td>
              </tr>
            </table>
          </td>
          <td style="vertical-align: top">
            <table class="third-area third-area-zhantie" cellpadding="0" cellspacing="0" style="border: none">
              <tr style="height: 32px;">
                <td style="width: 72px; border: none;"></td>
              </tr>
              <tr>
                <td class="color1" style="width: 72px; border: none;">TH</td>
              </tr>
              <tr>
                <td class="color1" style="width: 72px; border: none;">TJ</td>
              </tr>
              <tr>
                <td style="width: 72px; border: none;"></td>
              </tr>
              <tr>
                <td class="color1" style="width: 72px; border: none;">TK</td>
              </tr>
              <tr>
                <td class="color1" style="width: 72px; border: none;">TL</td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<style>
  #app {
    overflow: auto;
  }
</style>
<style scoped>
  .store-search-container {
    position: fixed;
    top: 0;
    right: 30px;
    left: 30px;
    background-color: #fff;
    padding: 5px 0;
  }
  .el-form .el-form-item {
    margin-left: 0;
    margin-bottom: 0;
  }
  table.third-area {
    width: auto;
    margin: 0 auto;
    border: 2px solid #333;
    border-top-width: 1px;
    border-right-width: 0px;
  }
  table.third-area tr {
    height: 30px;
  }
  table.third-area.third-area-zhantie tr {
    height: 60px;
  }
  table.third-area td {
    width: 68px;
    border-width: 1px;
    border-style: solid;
    border-color: #333;
    border-left: none;
    border-bottom: none;
  }
  table.third-area td.dashed {
    border-top-style: dashed;
  }
  table.third-area tr.last-location > td {
    border-bottom: 1px solid #333;
  }
  td.current {
    background-color: #00a;
    color: #fff;
    cursor: pointer;
  }
  td.outbound {
    background-color: #0a0;
    color: #fff;
  }
  td.color1 {
    background-color: #EEECE1;
  }
  td.color2 {
    background-color: #DCE6F1;
  }
</style>
<script>
export default {
  data: function () {
    return {
      query: {
        storageCategory: 'third',
        // 产品编号
        productCode: '',
        // 页码
        pageCode: '',
        // 番号
        designation: ''
      },
      // 所有产品
      products: [],
      pageCodes: [],
      designations: [],
      aColumns: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N'],
      taRows: [],
      bColumns: ['O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB'],
      tfRows: [],
      tgRows: []
    }
  },
  created: function () {
  },
  mounted: function () {
    // this.loadData()
    for (let i = 1; i <= 18; ++i) {
      this.taRows.push(i)
    }
    for (let i = 1; i <= 11; ++i) {
      this.tfRows.push(i)
    }
    for (let i = 1; i <= 13; ++i) {
      this.tgRows.push(i)
    }
  },
  methods: {
    // 加载数据
    loadData: function () {
      const _this = this
      _this.post(_this.$apis.getProducts, {}, function (res) {
        const _json = res.data
        _this.products = _json.products
      })
    },
    handerOutbound: function (positionNo, dom) {
      const _this = this
      _this.$confirm('出库操作不可逆, 确定出库?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // ajax提交至服务器，删除数据
        _this.post(_this.$apis.outBound, { category: '1', cage_codes: [positionNo] }, function (res) {
          let _json = res.data
          if (_json.status && _json.status === 'logout') {
            _this.logout()
          } else {
            if (_json.status === 'ok') {
              _this.$message({
                type: 'success',
                message: '删除成功!'
              })
              dom.className = 'outbound'
              dom.onclick = null
            } else {
              _this.$message({
                type: 'error',
                message: '无数据更新!'
              })
            }
          }
        })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handlerClear: function () {
      this.query = {
        storageCategory: 'second',
        // 产品Id
        productId: '',
        // 页码
        pageCode: [],
        // 番号
        designation: ''
      }
      if (this.isSearched) {
        this.handlerQueryLocation()
      }
    },
    // 刷新事件
    handlerRefresh: function () {
      this.loadData()
      if (this.isSearched) {
        this.handlerQueryLocation()
      }
    },
    handlerGetPageCode: function () {
      const _this = this
      // ajax提交至服务器，删除数据
      _this.post(_this.$apis.getPageCodes, { productId: _this.query.productId }, function (res) {
        let _json = res.data
        _this.pageCodes = _json.pageCodes
        _this.designations = _json.designations
      })
    },
    handlerProductChange: function (val) {
      const _this = this
      // ajax提交至服务器，删除数据
      _this.post(_this.$apis.getPageCodes, { productId: val }, function (res) {
        let _json = res.data
        _this.pageCodes = _json.pageCodes
        _this.designations = _json.designations
      })
    },
    // 根据产品名称、页码、番号，获取对应的库位
    handlerQueryLocation: function () {
      const _this = this
      let allTd = document.getElementsByTagName('td')
      for (let i = 0; i < allTd.length; ++i) {
        allTd[i].className = ''
      }
      let locationNumbers = []
      _this.post(_this.$apis.getStorageLocations, _this.query, function (res) {
        const _json = res.data
        // 获取到的库位号
        locationNumbers = _json.storageLocations
        if (locationNumbers.length > 0) {
          for (let i = 0; i < locationNumbers.length; ++i) {
            let _id = locationNumbers[i]
            let domTd = document.getElementById(_id)
            domTd.className = 'current'
            /*
            domTd.onclick = function () {
              _this.handerOutbound(_id, domTd)
            }
            */
          }
          _this.isSearched = true
        } else {
          _this.isSearched = false
        }
      })
    }
  },
  components: {
  }
}
</script>
